import { clsx } from "clsx";

import { Container } from "~/components/container";
import { FadeIn } from "~/components/fade-in";

import { SpriteName, Svg } from "./svg";

export function Testimonial({
  children,
  client,
  className,
}: {
  children: React.ReactNode;
  client: { logo: SpriteName; name: string };
  className?: string;
}) {
  return (
    <Container className={clsx(className)}>
      <FadeIn className="rounded-2xl border border-ink-700 bg-ink-900 px-6 py-14 sm:px-12 sm:py-16">
        <figure className="mx-auto max-w-3xl">
          <blockquote className="font-display text-2xl font-medium tracking-tight text-ink-50 sm:text-3xl">
            <p className="before:content-['“'] after:content-['”']">
              {children}
            </p>
          </blockquote>
          <figcaption className="mt-10 flex items-center gap-4">
            <span className="label text-ink-400">Client</span>
            <Svg
              className="w-32 text-ink-100"
              name={client.logo}
              aria-label={client.name}
            />
          </figcaption>
        </figure>
      </FadeIn>
    </Container>
  );
}
